<template>
  <v-dialog v-model="isOpen" max-width="800" max-height="800">
    <v-card>
      <v-card-title class="d-flex justify-space-between">
        <div>
          {{ this.$t("managedInstructionAssignment.tableHeader.user") }}
        </div>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :items="employees"
          :headers="headers"
          :items-per-page="10"
          :search="search"
          :options.sync="tableDataGetter.pagination"
          :footer-props="{
            itemsPerPageOptions: tableDataGetter.pagination.rowsPerPageItems,
            itemsPerPageText: $t('general.rowsPerPage'),
          }"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-text-field
                style="max-width: 370px"
                v-model="search"
                :label="$t('general.search')"
                id="search-all"
                single-line
                hide-details
                dense
                clearable
                @click:clear="handleClickClear()"
              ></v-text-field>
              <v-btn text icon color="secondary">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:item.employee.name="{ item }">
            {{ item.employee.name }}
          </template>
          <template v-slot:item.email="{ item }">
            {{ item.employee.email }}
          </template>
          <template v-slot:item.status="{ item }">
            <v-icon v-if="item.status === 'SUCCESS'" medium color="success">
              mdi-check
            </v-icon>
            <v-icon v-else medium color="grey">clear</v-icon>
          </template>
        </v-data-table>
      </v-card-text>

      <v-spacer />

      <v-card-actions>
        <v-spacer />
        <v-btn text color="primary" v-on:click="isOpen = false">{{
          $t("general.back")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "managedInstructionAssignmentTableEmployeeDialog",
  props: ["employees"],
  computed: {
    ...mapGetters(["tableDataGetter"]),
  },
  data() {
    return {
      isOpen: false,
      headers: [
        {
          text: this.$t("managedInstructionAssignment.employeeDialog.name"),
          value: "employee.name",
          align: "left",
        },
        {
          text: this.$t("managedInstructionAssignment.employeeDialog.email"),
          value: "employee.email",
          align: "left",
        },
        {
          text: this.$t("managedInstructionAssignment.employeeDialog.status"),
          value: "status",
          align: "center",
        },
      ],
      search: "",
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    handleClickClear() {
      this.search = "";
    },
  },
};
</script>
